import React, { Fragment, useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import Styles from "../DetailParcelle.scss";

const FiscalHabitation = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [asData, setAsData] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        props.detailLot ? fetchData() : null;
    }, [props.detailLot]);

    useEffect(() => {
        items.length > 0 ? setAsData(true) : setAsData(false);
    }, [items]);

    const fetchData = () => {
        setIsLoading(true);
        const params = {
            invar: props.detailLot,
        };
        axios
            .post("/Api/geodata/vmap/invariant/habitat", params)
            .then((result) => {
                setItems(result.data);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div id={"majic-parcelle"}>
            {asData ? (
                <Fragment>
                    <div
                        className={
                            "section section-data card ueThemeBackground ueColorBase border-0"
                        }
                    >
                        <div className="card-body section-body">
                            <div
                                className="ue-detail-parcelle-section-title"
                                style={{ fontWeight: "bold" }}
                            >
                                Habitation
                            </div>
                            <table
                                className="table table-condensed ue-table-data"
                                style={{ width: "100%", fontSize: "0.65rem" }}
                            >
                                <thead>
                                    <tr className={"text-left"}>
                                        <th
                                            style={{
                                                width: "30%",
                                                color: "#70989A",
                                            }}
                                        >
                                            Pev
                                        </th>
                                        <th
                                            style={{
                                                width: "30%",
                                                color: "#70989A",
                                            }}
                                        >
                                            Description
                                        </th>
                                        <th
                                            style={{
                                                width: "30%",
                                                color: "#70989A",
                                            }}
                                        >
                                            Confort
                                        </th>
                                    </tr>
                                </thead>
                                <tbody
                                    style={{
                                        fontSize: "0.60rem",
                                        whiteSpace: "pre-line",
                                    }}
                                >
                                    <tr>
                                        <td>Type : {items[0]?.pev}</td>
                                        <td>Type : {items[0]?.description}</td>
                                        <td>Type : {items[0]?.information}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Fragment>
            ) : isLoading ? (
                <div className="text-center my-2">
                    <Spinner animation="border" size={"sm"} />
                </div>
            ) : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        detailLot: state.LeftPanelReducer.detailLot,
        idLocal: state.LeftPanelReducer.idLocal,
        detailKeyPar: state.LeftPanelReducer.detailKeyPar,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {};
};
export default connect(mapStateToProps, mapDispatchTProps)(FiscalHabitation);
